import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { PersistGate } from 'redux-persist/integration/react';
import thunkMiddleware from 'redux-thunk';

import rootReducer from '../root-reducer';

const persistConfig = {
  key: 'mca-app',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const middlewareEnhancer = applyMiddleware(thunkMiddleware);

const defaultStore = createStore(
  persistedReducer,
  compose(middlewareEnhancer)
);

const defaultPersistor = persistStore(defaultStore);

export {
  Provider,
  PersistGate,
  defaultStore,
  defaultPersistor,
};
